import BaseOnboardingService from "./baseOnboarding.service";

class CoverageTypeService extends BaseOnboardingService {
  constructor() {
    super("coverage-type");
  }
}

export default new CoverageTypeService();
